/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiFormActionsRow from 'components/Forms/UiFormActionsRow'
import UiButton, { UiButtonSize, UiButtonStyle } from 'components/Ui/UiButton'
import UiFormStickyFloatFooter from 'components/Forms/UiFormStickyFloatFooter'
import UiFormStickyFooter from 'components/Forms/UiFormStickyFooter'

type UiFormActionsBarProps = {
    left?: React.ReactNode
    primaryText?: React.ReactNode
    onPrimary?: () => void
    secondaryText?: React.ReactNode
    onSecondary?: () => void
    saveAndCloseText?: React.ReactNode
    onSaveAndClose?: () => void
    backText?: React.ReactNode
    onBack?: () => void
    floatRight?: boolean
    disabled?: boolean
    loading?: boolean
    primaryId?: string
    secondaryId?: string
    saveAndCloseId?: string
    backId?: string
    className?: string
}

const UiFormActionsBar: React.FC<UiFormActionsBarProps> = ({
    left,
    primaryText,
    onPrimary,
    secondaryText,
    onSecondary,
    saveAndCloseText,
    onSaveAndClose,
    backText,
    onBack,
    floatRight,
    disabled,
    loading,
    className,
    primaryId,
    secondaryId,
    saveAndCloseId,
    backId,
}) => {
    const isDisabled = !!disabled || !!loading

    const Component = floatRight ? UiFormStickyFloatFooter : UiFormStickyFooter
    return (
        <Component className={clsx('UiFormActionsBar', className)}>
            <UiFormActionsRow
                left={
                    left ||
                    (onBack && (
                        <UiButton
                            id={backId}
                            size={UiButtonSize.Medium}
                            style={UiButtonStyle.Gray}
                            disabled={isDisabled}
                            onClick={onBack}
                        >
                            {backText}
                        </UiButton>
                    ))
                }
                right={
                    <>
                        {secondaryText && (
                            <UiButton
                                id={secondaryId}
                                size={UiButtonSize.Medium}
                                style={UiButtonStyle.Secondary}
                                disabled={isDisabled}
                                onClick={onSecondary}
                            >
                                {secondaryText}
                            </UiButton>
                        )}
                        {saveAndCloseText && (
                            <UiButton
                                id={saveAndCloseId}
                                size={UiButtonSize.Medium}
                                style={UiButtonStyle.Secondary}
                                disabled={isDisabled}
                                onClick={onSaveAndClose}
                            >
                                {saveAndCloseText}
                            </UiButton>
                        )}
                        {primaryText && (
                            <UiButton
                                id={primaryId}
                                size={UiButtonSize.Medium}
                                style={UiButtonStyle.Primary}
                                disabled={isDisabled}
                                onClick={onPrimary}
                            >
                                {primaryText}
                            </UiButton>
                        )}
                    </>
                }
            />
        </Component>
    )
}

export default UiFormActionsBar
